<template>
  <div class="w-full min-w-0 rounded-md border border-gray-200 bg-gray-50/50 p-3 dark:border-gray-800 dark:bg-gray-900/40">
    <div class="space-y-4">
      <slot />
    </div>
  </div>
</template>
